import { Box } from '../'
import './TapElement.scss'
import { assetUrl } from '../../../utilities'

export const TapElement = ({ x, y, w, h, pointDirection = 'left-up', ...props }) => {
  const positions = {
    'left-up': {
      left: x + w,
      top: y + h / 2 - 35
    },
    'right-up': {
      left: x - 186,
      top: y + h / 2 - 35
    },
    'left-down': {
      left: x + w,
      top: y + h / 2 - 100
    },
    'right-down': {
      left: x - 186,
      top: y + h / 2 - 100
    },
    'down': {
      left: x + (w / 2) - 100,
      top: y - 155
    },
    'up': {
      left: x + (w / 2) - 100,
      top: y + h + 15
    },
    'right-down-middle': {
      left: x + (w / 2) - 125,
      top: y - 130
    },
  }

  return (
    <Box
      position="fixed"
      left={positions[pointDirection]?.left}
      top={positions[pointDirection]?.top}
      className="tap-pointer"
      {...props}
    >
      <Box className={pointDirection}>
        <img src={assetUrl('tutorials/hand.svg')} alt="hand" style={{ width: 186 }} />
      </Box>
    </Box>
  )
}
